import React from 'react';

export const SectionHeader = ({ icon, title, count, theme, density, action, color }) => {
  const t = theme.typography || {};
  const e = theme.effects || {};
  const headingColor = color || theme.colors.accentLight;
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      marginBottom: density.spacing.sectionGap,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <span style={{ fontSize: '1.05rem', opacity: 0.9 }}>{icon}</span>
        <h2 style={{
          margin: 0,
          fontFamily: t.headingFamily || 'Georgia, serif',
          fontSize: density.typography.headingSize,
          fontWeight: 700,
          letterSpacing: '0.18em',
          textTransform: 'uppercase',
          color: headingColor,
          textShadow: e.headingTextShadow,
        }}>{title}</h2>
        {typeof count === 'number' && (
          <span style={{
            fontSize: density.typography.badgeSize,
            padding: '1px 9px',
            borderRadius: 999,
            background: 'rgba(0,0,0,0.45)',
            border: `1px solid ${theme.colors.borderLight}`,
            color: theme.colors.textMuted,
            fontFamily: t.monoFamily || 'ui-monospace, monospace',
          }}>{count}</span>
        )}
      </div>
      {action}
    </div>
  );
};
